export const getPageType = (url) => {
    const urlObject = new URL(url);
    const pathname = urlObject.pathname;
    const search = urlObject.search;
    const fullPath = pathname + search;
    // Check patterns in order of specificity
    if (pathname === '/') {
        return 'HOME';
    }
    if (/^\/(s|search)\//i.test(pathname)) {
        return 'SEARCH';
    }
    if (/^\/nav\//i.test(pathname)) {
        return 'NAV';
    }
    if (/(^\/offer\/buy\/)|(^\/mfp\/)/i.test(pathname)) {
        return 'FP';
    }
    // Super boutique check - multiple conditions
    if (document.querySelector('.shopPro') ||
        /\/offer\?action=desc&aid=/i.test(fullPath) ||
        /\/mfp\/shop\//i.test(pathname) ||
        /\/offer\/shop\//i.test(pathname) ||
        /\/boutique\//i.test(pathname)) {
        return 'SUPER_BOUTIQUE';
    }
    if (/^\/v\/vendre/i.test(pathname)) {
        return 'SELL';
    }
    if (/^\/event\//i.test(pathname)) {
        return 'EVENT';
    }
    // Mon compte check - multiple conditions
    if (/^(\/user$)/.test(pathname) ||
        /^\/memo\?action=list/.test(fullPath) ||
        /^\/purchase\?action=buylist/.test(fullPath) ||
        /^\/purchase\?action=itemmonitoring&itemid=/.test(fullPath) ||
        /^\/usersecure\?action=rakutenclubhistory/.test(fullPath) ||
        /^\/usersecure\?action=clubaccount/.test(fullPath)) {
        return 'MON_COMPTE';
    }
    // Default case
    return 'OTHER';
};
